import { NotifyErrorWrapper, NotifySuccess } from '@/helpers/core/notifications'
import {
  createLMPThresholdAlert,
  deleteLMPThresholdAlert,
  getLMPThresholdAlerts,
  updateLMPThresholdAlert,
} from '@/services/eos/alerts/lmp-alerts.service'
import type { IISORealTimeLMPThresholdForm } from '@/types/eos/alerts/forms'
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'

export const useRealTimeLMPThresholds = () => {
  const queryClient = useQueryClient()

  const getRealTimeLMPThresholdsQuery = () =>
    useQuery({
      queryKey: ['lmp-threshold-alerts'],
      queryFn: () => getLMPThresholdAlerts(),
    })

  const createRealTimeLMPThresholdMutation = useMutation({
    mutationFn: (lmpAlertForm: IISORealTimeLMPThresholdForm) => createLMPThresholdAlert(lmpAlertForm),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['lmp-threshold-alerts'] })
      NotifySuccess('Threshold created')
    },
    onError: NotifyErrorWrapper('Failed to create threshold'),
  })

  const updateRealTimeLMPThresholdMutation = useMutation({
    mutationFn: (lmpAlertForm: IISORealTimeLMPThresholdForm) => updateLMPThresholdAlert(lmpAlertForm),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['lmp-threshold-alerts'] })
      NotifySuccess('Threshold updated')
    },
    onError: NotifyErrorWrapper('Failed to update threshold'),
  })

  const deleteRealTimeLMPThresholdMutation = useMutation({
    mutationFn: (id: number) => deleteLMPThresholdAlert(id),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['lmp-threshold-alerts'] })
      NotifySuccess('Threshold deleted')
    },
    onError: NotifyErrorWrapper('Failed to delete threshold'),
  })

  return {
    getRealTimeLMPThresholdsQuery,
    createRealTimeLMPThresholdMutation,
    updateRealTimeLMPThresholdMutation,
    deleteRealTimeLMPThresholdMutation,
  }
}
